import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '90%',
    },
  },
}));

export interface TextAreaInputDialogProps{
  handleClose: (value: string, questionIndex: number) => void,
  open: boolean,
  value: string,
  index: number,
  title: string,
  label: string
}

export default function TextAreaInputDialog(props: TextAreaInputDialogProps) {
  const classes = useStyles();
  const [value, setValue] = React.useState("");

  useEffect(() =>{
    if(props.open === true)
    {
      setValue(props.value)
    }
  },[props.open, props.value])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value); 
  };


  return (
    <Dialog fullWidth={true}
      maxWidth={'md'}  aria-labelledby="simple-dialog-title" open={props.open}>
      <DialogTitle id="simple-dialog-title">{props.title}</DialogTitle>
    <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          id="outlined-multiline-flexible"
          label={props.label}
          multiline
          maxRows={15}
          rows={5}
          value={value}
          onChange={handleChange}
          variant="outlined"
        />
      </div>
    </form>
    <DialogActions>
      <Button onClick={() => {props.handleClose(value, props.index)}}>Done</Button>
    </DialogActions>
    </Dialog>
  );
}